export enum TppStatus {
    TppAprroved = "Active",
    TppDenied = "Denied",
    TppRequestToTrade = "Request To Trade",
    TppSubmitted = "Submitted"
}